import { Button, Typography, TypographyProps } from "@suraasa/placebo-ui"
import clsx from "clsx"
import React from "react"

type Props = {
  maxLength: number
  className?: string
  hideActionButton?: boolean
  children?: string
} & TypographyProps

const TruncatedText = ({
  maxLength,
  hideActionButton = false,
  children,
  className,
  ...props
}: Props) => {
  const [seeAll, setSeeAll] = React.useState(false)

  return (
    <div className={className}>
      <Typography
        className={clsx("inline whitespace-pre-line")}
        style={{ wordBreak: "break-word" }}
        {...props}
      >
        {children &&
          (!seeAll && children.length > maxLength
            ? `${children.slice(0, maxLength)}...`
            : children)}
      </Typography>

      {!hideActionButton &&
        children &&
        children.toString().length > maxLength && (
          <div>
            <Button
              className="ms-0.5 inline"
              onClick={() => setSeeAll(!seeAll)}
            >
              {seeAll ? "Read Less" : "Read More"}
            </Button>
          </div>
        )}
    </div>
  )
}

export default TruncatedText
